import { render, staticRenderFns } from "./DisplayWaiting.vue?vue&type=template&id=6382b1db&scoped=true&"
import script from "./DisplayWaiting.vue?vue&type=script&lang=js&"
export * from "./DisplayWaiting.vue?vue&type=script&lang=js&"
import style0 from "./DisplayWaiting.vue?vue&type=style&index=0&id=6382b1db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6382b1db",
  null
  
)

export default component.exports